// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  username: string;
  notificationID: string | number;
}

export function useUpdateUsernameMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function updateUsername(params: paramsType): Promise<any> {
    const response = await api.post<any>(
      `account/changeusername/${params.username}`
    );

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: updateUsername,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
